function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 32,
  x: 1,
  y: 1,
  stroke: "#757575",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#757575",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M13.5 9.2c1.933 0 3.5 1.88 3.5 4.2h-7c0-2.32 1.567-4.2 3.5-4.2zm0-4.2a2.1 2.1 0 1 1-.002 4.202A2.1 2.1 0 0 1 13.5 5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#757575",
  fillRule: "nonzero",
  d: "M13.5 17.079c-.895 0-1.727.247-2.425.678a.393.393 0 0 0-.125.522c.103.17.353.233.519.13a3.845 3.845 0 0 1 2.031-.57c2.05 0 3.66 1.527 3.66 3.405v.832c0 .202.179.386.38.386.202 0 .38-.184.38-.386v-.832c0-2.314-1.995-4.165-4.42-4.165zm-3.517 1.636c-.59.678-.903 1.577-.903 2.53v4.34a.394.394 0 0 0 .38.386c.197 0 .38-.184.376-.386v-4.34c0-.773.272-1.479.733-2.05.099-.112.135-.292.054-.413-.188-.279-.447-.288-.64-.068zm3.517-.072c-1.683 0-3.074 1.285-3.074 2.902v.742a.393.393 0 0 0 .376.386.393.393 0 0 0 .38-.386v-.742c0-1.177 1.016-2.143 2.318-2.143s2.313.966 2.313 2.143v5.307a.392.392 0 0 0 .376.382.392.392 0 0 0 .38-.382v-5.307c0-1.617-1.386-2.902-3.069-2.902zm0 1.514c-.935 0-1.732.72-1.732 1.64v6.057a.4.4 0 0 0 .38.387.4.4 0 0 0 .381-.387v-6.057c0-.48.412-.88.971-.88.555 0 .966.4.966.88v1.622a.393.393 0 0 0 .38.382c.198 0 .38-.184.377-.382v-1.622c0-.921-.788-1.64-1.723-1.64zm-.009 1.353a.399.399 0 0 0-.371.386v3.581a.394.394 0 0 0 .38.387.39.39 0 0 0 .376-.387v-3.581a.394.394 0 0 0-.385-.386zm4.04 1.397a.395.395 0 0 0-.371.382v2.296c0 .202.179.387.38.387.202 0 .38-.185.38-.387V23.29a.397.397 0 0 0-.389-.382zm-6.73.252a.393.393 0 0 0-.375.386v3.307a.392.392 0 0 0 .376.382.393.393 0 0 0 .38-.382v-3.307a.397.397 0 0 0-.38-.386zm4.001 1.141a.395.395 0 0 0-.335.386v3.168a.397.397 0 0 0 .38.387c.197 0 .38-.189.376-.387v-3.168a.394.394 0 0 0-.38-.386h-.04zm-1.351 2.094a.396.396 0 0 0-.331.39v1.322a.394.394 0 0 0 .38.387.39.39 0 0 0 .376-.387v-1.321a.392.392 0 0 0-.385-.391h-.04z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#757575",
  strokeLinecap: "square",
  d: "M21.5 5.5v23"
}));

var SvgRgListIcon = function SvgRgListIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 34,
    viewBox: "0 0 26 34",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRgListIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rg_list_icon.cc9cb211.svg";
export { ForwardRef as ReactComponent };